import { render, staticRenderFns } from "./BonusCard.vue?vue&type=template&id=596d1b6c"
import script from "./BonusCard.vue?vue&type=script&lang=js"
export * from "./BonusCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsNuxtImage: require('/app/components/Commons/NuxtImage.vue').default})
